<template>
<layout-basic>
  <v-container grid-list-md text-xs-left fluid>
    <v-layout row wrap>
        <!--<v-card flat height="100%" class="pa-1">-->
          <!--<v-card-text class="px-0">-->
      <v-col md="12" class="pa-1" style="margin-left:25%" >
        <v-row>
          <v-col md="6" style="text-align:justify;font-weight: bold;"><u>Client Referral Link:</u></v-col>
        </v-row>
        <v-row>
          <v-col md="6" style="text-align:justify">
            <p>If you know of a company that would benefit from IMPROVE but don't wish to have the ability to manage or access their account on their behalf through the Partner Hub, we're here to help.</p>
            <p>Our friendly support team will make sure your customers are up and running in no time and will be pleased to answer their questions. And it doesn't stop there. Ongoing support is included in all our subscription plans.</p>
            <p>Please share the unique referral code below with your customers and we'll be able to tell that it's you we need to send love and thanks for recommending us.</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" style="text-align:justify;font-weight: bold;"><u>Referral Code:</u> {{referralLink}}</u></v-col>
        </v-row>
      </v-col>
    </v-layout>
  </v-container>
</layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/PartnerHub";
export default {
  name: "UsersPartner",
  components: {
    LayoutBasic
  },
  computed: {
    referralLink: function() {
      if (this.$store.getters.companyReferralCode != "" && this.$store.getters.companyReferralCode != null) {
        return this.$store.getters.companyReferralCode;
      } else {
        return "Coming Soon";
      }
    }
  }
};
</script>
